<template>
    <div data-testid="comments">
        <v-tooltip v-if="!hideTrigger" bottom content-class="tooltip-bottom" data-testid="comments__tooltip">
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="comments__open-btn minWid pa-0" name="conversations" v-bind="attrs" v-on="on" text
                    @click="conversationList = []; getProjectCon(true)"
                    data-testid="comments__open-btn">
                    <v-badge class="comments__badge-wrap" color="error" offset-x="10" offset-y="10" top dot :value="notify" data-testid="comments__badge">
                        <img
                            :class="['comments__icon', { 'comments__icon--highlight': highlight }]"
                            data-testid="comments__icon-main"
                            src="/img/icons/fbc-icons/CommentsIcon.svg"
                            alt="Comments Icon"
                        />
                    </v-badge>
                    <span v-if="showname" class="text-capitalize" data-testid="comments__title">Comments</span>
                </v-btn>
            </template>
            <span data-testid="comments__tooltip-title">Comments</span>
        </v-tooltip>

        <lb-drawer v-model="dialog" :heading="heading" persistent :dailogboxOnly="true" data-testid="comments__drawer">
            <template v-slot:body>
                <div style="max-height:70vh; overflow:scroll" ref="chatContainer" data-testid="comments__body">
                    <div class="" data-testid="comments__chat-container">
                        <div v-for="(item, index) in conversationList" :key="index" data-testid="comments__item">
                            <!-- you -->
                             <div
                                class="d-flex align-center justify-end mt-3"
                                v-if="String(item.user) === String(currentUserId)"
                                data-testid="comments__item-row"
                             >
                                 <template v-if="(conversationList[index - 1] || {}).user !== item.user">
                                     <span
                                        class="mr-2"
                                        data-testid="comments__item-avatar-name"
                                     >{{ getUserName(item) }}</span>
                                     <v-tooltip bottom data-testid="comments__item-tooltip">
                                         <template v-slot:activator="{ on, attrs }">
                                             <v-avatar class="ml-2" size="30" elevation="10" v-bind="attrs" v-on="on" color="indigo" data-testid="comments__item-avatar">
                                                 <v-img
                                                    v-if="shouldShowProfileImage(item)"
                                                    alt="Avatar"
                                                    width="30px"
                                                    height="30"
                                                    :size="30"
                                                    :src="getUserProfileUrl(item)"
                                                    @error="onProfileImageError(item)"
                                                    data-testid="comments__item-avatar-img"
                                                 />
                                                 <span class="white--text" v-else data-testid="comments__item-avatar-initial">{{ getUserInitials(item) }}</span>
                                             </v-avatar>
                                         </template>
                                         <span data-testid="comments__item-avatar-name-tooltip">{{ getUserName(item) }}</span>
                                    </v-tooltip>
                                 </template>
                                <span v-else class="mr-9" data-testid="comments__item-avatar-gap"></span>
                             </div>
                            <div class="mb-2 d-flex flex-column all-width justify-end" v-if="String(item.user) === String(currentUserId)" data-testid="comments__item-message-row">
                                    <div class="timeFont mr-8 text-right mt-0" data-testid="comments__item-date">
                                        {{
                                            $nova.formatDateTime(item.created_at, "DD MMM yyyy hh:mm A")
                                        }}
                                    </div>
                                    <v-card  class="mr-8 shadow-off radius-small"
                                         color="purpleborder" data-testid="comments__item-message-card">
                                        <v-card-text class="shadow-off" data-testid="comments__item-message-text">
                                            <div class="black--text" :id="'sent-chat-message-' + index" data-testid="comments__item-message">{{ item.value }}</div>
                                        </v-card-text>
                                    </v-card>
                            </div>
                            <!-- sender -->
                            <div class="mt-2" v-else data-testid="comments__item-row-other">
                                <div class="d-flex align-center " v-if="(conversationList[index - 1] || {}).user !== item.user" data-testid="comments__item-tooltip-other">
                                    <v-tooltip bottom data-testid="comments__item-tooltip-other-inner">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-avatar dark class="" size="30"  v-bind="attrs" v-on="on" color="indigo" data-testid="comments__item-avatar-other">
                                                <v-img
                                                    v-if="shouldShowProfileImage(item)"
                                                    alt="Avatar"
                                                    width="30px"
                                                    height="30"
                                                    :size="30"
                                                    :src="getUserProfileUrl(item)"
                                                    @error="onProfileImageError(item)"
                                                    data-testid="comments__item-avatar-img"
                                                ></v-img>
                                                <span class="white--text" v-else data-testid="comments__item-avatar-initial-other">{{ getUserInitials(item) }}</span>
                                            </v-avatar>
                                        </template>
                                        <span data-testid="comments__item-avatar-name-other">{{ getUserName(item) }}</span>
                                    </v-tooltip>
                                    <span class="ml-2" data-testid="comments__item-avatar-name-label-other">{{ getUserName(item) }}</span>
                                </div>
                                <div v-else class="ml-9" data-testid="comments__item-avatar-gap-other"></div>
                                <div class="mb-2 d-flex flex-column all-width justify-start" data-testid="comments__item-message-row-other">
                                    <div class="ml-8" data-testid="comments__item-date-other">
                                        {{
                                            $nova.formatDateTime(item.created_at, "DD MMM yyyy hh:mm A")
                                        }}
                                    </div>
                                    <v-card class="ml-8 radius-small shadow-off" color="lightgray" data-testid="comments__item-message-card-other">
                                        <v-card-text data-testid="comments__item-message-text-other">
                                            <div class="" :id="'receive-chat-message-' + index" data-testid="comments__item-message-other">{{ item.value }}</div>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </div>
                        </div>
                        <div v-if="(conversationList || []).length === 0"
                            class="d-flex flex-column align-center justify-center  all-height" data-testid="comments__empty-state">
                            <v-spacer data-testid="comments__empty-state-spacer-top"></v-spacer>
                            <p class="text-subtitle-1 grey--text" data-testid="comments__empty-state-label">Be the first one to comment</p>
                            <v-spacer data-testid="comments__empty-state-spacer-bottom"></v-spacer>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:actions v-if="!closed">
                <div class="d-flex align-center mb-1" v-if="recurring" data-testid="comments__recurring-row">
                    <v-checkbox label="Reucurring Comment" class="mr-2 pa-0 ma-0" dense hide-details
                        v-model="recurringMsg" data-testid="comments__recurring-checkbox"></v-checkbox>
                    <v-tooltip right content-class="tooltip-right" data-testid="comments__recurring-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="blue-grey lighten-2" dark v-bind="attrs" v-on="on" data-testid="comments__recurring-icon">
                                mdi-help-circle-outline
                            </v-icon>
                        </template>
                        <span class="text-justify" data-testid="comments__recurring-tooltip-text">{{ recurringtext }}</span>
                    </v-tooltip>
                </div>
                <div class="d-flex align-center all-width" data-testid="comments__input-row">
                    <lb-string placeholder="Type your message here" label="" hidedetails @enter="sendQuery()"
                        v-model="queryMsg" :isRequired="true" :error="sendError" data-testid="comments__input" />
                    <v-btn color="primary" class="ml-3" :loading="sendLoading || loading" @click="sendQuery()" data-testid="comments__send-btn">
                        <v-icon color="white" data-testid="comments__send-icon">mdi-send</v-icon></v-btn>
                </div>
            </template>
        </lb-drawer>
    </div>
</template>
<script>
export default {
    name: "conversations",
    model: {
        prop: 'drawerOpen',
        event: 'input',
    },
    data() {
        return {
            internalDialog: false,
            loading: false,
            conversationList: [],
            queryMsg: "",
            recurringMsg: false,
            failedProfileUrls: {},
        };
    },
    props: {
        /** Drawer open state (use with hideTrigger + v-model) */
        drawerOpen: {
            type: Boolean,
            default: undefined,
        },
        /** Hide toolbar button; parent opens drawer via v-model */
        hideTrigger: {
            type: Boolean,
            default: false,
        },
        /** Embedded comments list (Information Manager); maps comment → value */
        comments: {
            type: Array,
            default: () => [],
        },
        /** Parent-controlled send loading (embedded mode) */
        sendLoading: {
            type: Boolean,
            default: false,
        },
        /** Parent-controlled send validation error (embedded mode) */
        sendError: {
            type: String,
            default: '',
        },
        getapi: {
            type: String,
            default: "",
        },
        sendapi: {
            type: String,
            default: "",
        },
        readapi: {
            type: String,
            default: "",
        },
        heading: {
            type: String,
            default: "Conversation",
        },
        recurring: {
            type: Boolean,
            default: false,
        },
        recurringtext: {
            type: String,
            default: "Requirements comments for next time",
        },
        notify: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: "800",
        },
        type: {
            type: String,
            default: "string",
        },
        closed: {
            type: Boolean,
            default: true,
        },
        highlight: {
            type: Boolean,
            default: false
        },
        showprofile: {
            type: Boolean,
            default: true
        },
        showname:{
            type:Boolean,
            default: false,
        },
        userList: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        dialog: {
            get() {
                return this.hideTrigger ? !!this.drawerOpen : this.internalDialog;
            },
            set(val) {
                if (this.hideTrigger) {
                    this.$emit('input', val);
                } else {
                    this.internalDialog = val;
                }
            },
        },
        currentUserId() {
            return this.$store.state.user?.id || this.$store.state.user?._id || '';
        },
    },
    watch: {
        conversationList() {
            this.failedProfileUrls = {};
        },
        drawerOpen(val) {
            if (this.hideTrigger && val) {
                this.syncCommentsFromProp();
                this.$nextTick(() => this.scrollToBottom());
            }
        },
        comments: {
            handler() {
                if (this.hideTrigger && this.dialog) {
                    this.syncCommentsFromProp();
                    this.$nextTick(() => this.scrollToBottom());
                }
            },
            deep: true,
        },
    },
    methods: {
        syncCommentsFromProp() {
            this.conversationList = (this.comments || []).map((item) => ({
                ...item,
                value: item.value != null ? item.value : item.comment,
            }));
        },
        resetMessage() {
            this.queryMsg = '';
        },
        sendQuery() {
            const text = (this.queryMsg || '').trim();
            if (!text) return;
            if (this.hideTrigger && !this.sendapi) {
                this.$emit('send', text);
                return;
            }
            this.loading = true;
            let dataObject = {
                type: this.type,
                value: text,
                status: this.status,
            };
            // console.log(dataObject);
            let successflag = false;
            this.axios
                .post(this.sendapi, { data: dataObject })
                .then((dt) => {
                    if (dt.data.status === "success") {
                        successflag = true;
                        // this.$store.commit("sbSuccess", "successfully sended");
                        this.queryMsg = "";

                    } else throw Error(dt.data.message || "Unknown error")
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                    if (successflag) this.getProjectCon();
                });
        },
        getProjectCon(mark = false) {
            if (this.hideTrigger) {
                this.dialog = true;
                this.syncCommentsFromProp();
                if (mark) this.$emit('markread');
                this.$nextTick(() => this.scrollToBottom());
                return;
            }
            this.dialog = true;
            this.loading = true;
            this.axios
                .post(this.getapi)
                .then((dt) => {
                    if (dt.data.status === "success") {
                        this.conversationList = dt.data.data;
                        this.dialog=true                        
                        if (mark) this.markAsRead();
                    } else throw Error(dt.data.message || "Unknown error")
                    // console.log(this.conversationList);
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                    this.scrollToBottom();
                });
        },
        markAsRead() {
            this.axios
                .post(this.readapi)
                .then((dt) => {
                    if (dt.data.status === "success") {
                        this.$emit("markread");
                    } else throw Error(dt.data.message || "Unknown error")
                    // console.log(this.conversationList);
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                });
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const chatContainer = this.$refs.chatContainer;
                if (chatContainer) {
                    chatContainer.scrollTop = chatContainer.scrollHeight;
                }
            });
        },
        getCurrentUserId() {
            return this.$store.state.user?.id || this.$store.state.user?._id || null;
        },
        findUserRecord(userId) {
            if (userId == null || !this.userList.length) return null;
            return this.userList.find(
                (u) => String(u._id) === String(userId) || String(u.id) === String(userId)
            ) || null;
        },
        resolveProfileUrl(record) {
            if (!record) return null;
            const url = record.profile_url || record.profile || record.avatar_url || record.avatar;
            return (typeof url === 'string' && url.trim()) ? url.trim() : null;
        },
        shouldShowProfileImage(item) {
            if (!this.showprofile) return false;
            const url = this.getUserProfileUrl(item);
            if (!url || this.failedProfileUrls[url]) return false;
            return true;
        },
        onProfileImageError(item) {
            const url = this.getUserProfileUrl(item);
            if (url) this.$set(this.failedProfileUrls, url, true);
        },
        getUserName(item) {
            if (item?.user_detail?.name) {
                return item.user_detail.name;
            }
            const userId = item?.user;
            if (userId != null && String(userId) === String(this.getCurrentUserId())) {
                return this.$store.state.user?.name || this.$store.state.user?.email || 'NA';
            }
            const user = this.findUserRecord(userId);
            if (user?.name) return user.name;
            if (item?.user_detail?.email) {
                return item.user_detail.email;
            }
            if (user?.email) return user.email;
            return 'NA';
        },
        getUserInitials(item) {
            const name = this.getUserName(item);
            if (name && name !== 'NA') return name.charAt(0).toUpperCase();
            const email = item?.user_detail?.email
                || this.findUserRecord(item?.user)?.email
                || (String(item?.user) === String(this.getCurrentUserId()) ? this.$store.state.user?.email : null);
            if (email) return email.charAt(0).toUpperCase();
            return '?';
        },
        getUserProfileUrl(item) {
            const fromDetail = this.resolveProfileUrl(item?.user_detail);
            if (fromDetail) return fromDetail;

            const userId = item?.user;
            if (userId != null && String(userId) === String(this.getCurrentUserId())) {
                const fromStore = this.resolveProfileUrl(this.$store.state.user);
                if (fromStore) return fromStore;
            }

            return this.resolveProfileUrl(this.findUserRecord(userId));
        },
    },
    mounted() {
        // Auto-scroll to the bottom when the component is mounted
        this.scrollToBottom();
    }
};
</script>

<style>
.minWid {
    min-width: 36px !important;
}

.comments__open-btn {
    display: inline-flex;
    align-items: center;
}

.comments__badge-wrap {
    line-height: 0;
}

.comments__badge-wrap .v-badge__badge {
    top: 2px;
    right: -2px;
    min-width: 8px;
    height: 8px;
}

.comments__icon {
    width: 1.25rem;
    height: 1.25rem;
    display: block;
    opacity: 0.85;
    filter: grayscale(1) brightness(0.72);
    transition: filter 0.2s ease, opacity 0.2s ease;
}

.comments__icon--highlight {
    opacity: 1;
    filter: none;
}
</style>
